


// import { useMemo, useState } from "react";
// import debounce from "lodash.debounce";
// import axiosInstance from "../../api/axiosInstance";
// import SectionCard from "../ui/SectionCard";
// import { validationTypeOptions } from "../../data/formDefaults";

// // ── Reusable error-aware field wrapper ────────────────────
// function FieldError({ message }) {
//   if (!message) return null;
//   return <p className="text-red-500 text-[11px] mt-1">{message}</p>;
// }

// function inputCls(hasError) {
//   return `
//     flex-1 border px-5 py-2 text-sm text-gray-800 bg-white
//     focus:outline-none focus:ring-1
//     ${hasError
//       ? "border-red-500 focus:ring-red-400"
//       : "border-gray-400 focus:ring-blue-500"
//     }
//   `;
// }

// function selectCls(hasError) {
//   return `
//     flex-1 border px-8 py-1 text-sm text-gray-900 bg-white
//     focus:outline-none focus:ring-1
//     ${hasError
//       ? "border-red-500 focus:ring-red-400"
//       : "border-gray-400 focus:ring-blue-500"
//     }
//   `;
// }

// export default function GeneralInfoSection({ form, errors, setField }) {
//   console.log("form:.... ", form);
  
//   const user = JSON.parse(localStorage.getItem("user"));
//   const today = new Date().toISOString().split("T")[0];

//   // const [phoneError,   setPhoneError]   = useState("");
//   const [mpanRecords,  setMpanRecords]  = useState([]);
//   const [phoneLoading, setPhoneLoading] = useState(false);

//   const checkPhoneExists = async (phone) => {
//     try {
//       setPhoneLoading(true);
//       const response = await axiosInstance.get(`/leads/check-phone/${phone}`);
//       if (response.data.exists) {
//         // setPhoneError("Business phone already exists");
//         setMpanRecords(response.data.records || []);
//       } else {
//         // setPhoneError("");
//         setMpanRecords([]);
//       }
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setPhoneLoading(false);
//     }
//   };

//   const debouncedPhoneCheck = useMemo(
//     () => debounce((phone) => checkPhoneExists(phone), 500),
//     []
//   );

//   const handlePhoneChange = (e) => {
//     const value = e.target.value.replace(/\D/g, "");
//     if (value.length <= 15) {
//       setField("businessPhone")({ target: { name: "businessPhone", value } });
//       if (value.length >= 8) {
//         debouncedPhoneCheck(value);
//       } else {
//         // setPhoneError("");
//         setMpanRecords([]);
//       }
//     }
//   };

//   return (
//     <SectionCard title="GENERAL INFORMATION">
//       <div className="border border-gray-300 bg-[#dbe9f5] p-6">
//         <div className="grid grid-cols-2 gap-x-8 gap-y-5">

//           {/* LEAD ID */}
//           <div className="flex items-center gap-3">
//             <label className="w-44 text-[12px] font-semibold text-gray-500 uppercase">Lead ID</label>
//             <input
//               type="text"
//               disabled
//               placeholder="Auto Generated"
//               className="flex-1 border border-gray-400 px-5 py-1 text-sm bg-gray-100"
//             />
//           </div>

//           <div></div>

//           {/* VALIDATE TYPE */}
//           <div className="flex items-start gap-3">
//             <label className="w-44 text-[12px] font-semibold text-gray-700 uppercase pt-3">
//               Validate Type *
//             </label>
//             <div className="flex-1">
//               <select
//                 name="validationType"
//                 value={form.validationType || ""}
//                 onChange={setField("validationType")}
//                 className={selectCls(errors.validationType)}
//               >
//                 <option value="">Select Type</option>
//                 {validationTypeOptions.map((item) => (
//                   <option key={item} value={item}>{item}</option>
//                 ))}
//               </select>
//               <FieldError message={errors.validationType} />
//             </div>
//           </div>

//           {/* AGENT ID */}
//           <div className="flex items-center gap-3">
//             <label className="w-36 text-[12px] font-semibold text-gray-700 uppercase">Agent ID</label>
//             <input
//               type="text"
//               value={user?.id || ""}
//               placeholder="Auto Generated"
//               disabled 
//               className="flex-1 border border-gray-400 px-3 py-2 text-sm bg-gray-100"

//             />
//           </div>

//           {/* LEAD DATE */}
//           <div className="flex items-center gap-3">
//             <label className="w-44 text-[12px] font-semibold text-gray-700 uppercase">Lead Date</label>
//             <input
//               type="date"
//               value={form.leadDate || today}
//               disabled
//               className="flex-1 border border-gray-400 px-4 py-2 text-sm bg-gray-100 text-gray-900"
//             />
//           </div>

//           {/* CUSTOMER NAME */}
//           <div className="flex items-start gap-3">
//             <label className="w-36 text-[12px] font-semibold text-gray-700 uppercase pt-3">
//               Customer Name *
//             </label>
//             <div className="flex-1">
//               <input
//                 name="contactName"
//                 type="text"
//                 value={form.contactName || ""}
//                 onChange={setField("contactName")}
//                 placeholder="Enter customer name"
//                 className={inputCls(errors.contactName)}
//               />
//               <FieldError message={errors.contactName} />
//             </div>
//           </div>

//           {/* BUSINESS NAME */}
//           <div className="flex items-start gap-3">
//             <label className="w-44 text-[12px] font-semibold text-gray-700 uppercase pt-3">
//               Business Name *
//             </label>
//             <div className="flex-1">
//               <input
//                 name="businessName"
//                 type="text"
//                 value={form.businessName || ""}
//                 onChange={setField("businessName")}
//                 placeholder="Enter business name"
//                 className={inputCls(errors.businessName)}
//               />
//               <FieldError message={errors.businessName} />
//             </div>
//           </div>

//           {/* BILLING NAME */}
//           <div className="flex items-start gap-3">
//             <label className="w-36 text-[12px] font-semibold text-gray-700 uppercase pt-3">
//               Billing Name *
//             </label>
//             <div className="flex-1">
//               <input
//                 name="billingName"
//                 type="text"
//                 value={form.billingName || ""}
//                 onChange={setField("billingName")}
//                 placeholder="Enter billing name"
//                 className={inputCls(errors.billingName)}
//               />
//               <FieldError message={errors.billingName} />
//             </div>
//           </div>

//           {/* BUSINESS ADDRESS */}
//           <div className="flex items-start gap-3">
//             <label className="w-44 pt-3 text-[12px] font-semibold text-gray-700 uppercase">
//               Business Address *
//             </label>
//             <div className="flex-1">
//               <textarea
//                 name="businessAddress"
//                 rows={6}
//                 value={form.businessAddress || ""}
//                 onChange={setField("businessAddress")}
//                 placeholder="Enter business address"
//                 className={`
//                   w-full border px-4 py-2 text-sm text-gray-900 bg-white resize-none
//                   focus:outline-none focus:ring-1
//                   ${errors.businessAddress
//                     ? "border-red-500 focus:ring-red-400"
//                     : "border-gray-400 focus:ring-blue-500"
//                   }
//                 `}
//               />
//               <FieldError message={errors.businessAddress} />
//             </div>
//           </div>

//           {/* RIGHT COLUMN: PHONE + MPAN RECORDS + MPAN INPUT */}
//           <div className="space-y-4">

//             {/* PHONE */}
//             <div className="flex items-start gap-3">
//               <label className="w-36 text-[12px] font-semibold text-gray-700 uppercase pt-3">
//                 Phone No *
//               </label>
//               <div className="flex-1">
//                 <input
//                   name="businessPhone"
//                   type="tel"
//                   value={form.businessPhone || ""}
//                   onChange={handlePhoneChange}
//                   placeholder="Enter phone number"
//                   className={`
//                     w-full border px-4 py-2 text-sm text-gray-900 bg-white
//                     focus:outline-none focus:ring-1
                  
//                   `}
//                 />
//                 {/* <FieldError message={phoneError || errors.businessPhone} /> */}
//               </div>
//             </div>

//             {/* LOADING */}
//             {phoneLoading && (
//               <p className="text-xs text-gray-400 italic pl-1">Checking phone...</p>
//             )}

//             {/* MPAN RECORDS TABLE */}
//             {/* {!phoneLoading && mpanRecords.length > 0 && (
//               <div className="border border-orange-300 bg-white rounded overflow-hidden">
//                 <div className="px-3 py-2 bg-orange-100 border-b border-orange-300">
//                   <p className="text-[11px] font-bold text-orange-700 uppercase tracking-wide">
//                     ⚠ Existing Records for this Phone Number
//                   </p>
//                 </div>
//                 <table className="w-full text-xs">
//                   <thead>
//                     <tr className="bg-orange-50 text-gray-500 uppercase">
//                       <th className="px-3 py-2 text-left font-semibold w-8">#</th>
//                       <th className="px-3 py-2 text-left font-semibold">MPAN</th>
//                       <th className="px-3 py-2 text-left font-semibold">Disposition</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {mpanRecords.map((record, index) => (
//                       <tr key={index} className="border-t border-orange-100 hover:bg-orange-50 transition">
//                         <td className="px-3 py-2 text-gray-400">{index + 1}</td>
//                         <td className="px-3 py-2 font-mono text-gray-800">{record.mpan || "—"}</td>
//                         <td className="px-3 py-2">
//                           <span className={`
//                             px-2 py-0.5 rounded text-[10px] font-bold uppercase
//                             ${record.lead_disposition === "Sale"    ? "bg-green-100 text-green-700"
//                             : record.lead_disposition === "Reject"  ? "bg-red-100 text-red-700"
//                             : record.lead_disposition === "Hold"    ? "bg-yellow-100 text-yellow-700"
//                             : "bg-gray-100 text-gray-600"}
//                           `}>
//                             {record.lead_disposition || "—"}
//                           </span>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             )} */}

//             {form.validationType !== "Gas Only" &&
//   !phoneLoading &&
//   mpanRecords.length > 0 && (
//     <div className="border border-orange-300 bg-white rounded overflow-hidden">
//       <div className="px-3 py-2 bg-orange-100 border-b border-orange-300">
//         <p className="text-[11px] font-bold text-orange-700 uppercase tracking-wide">
//           ⚠ Existing Records for this Phone Number
//         </p>
//       </div>

//       <table className="w-full text-xs">
//         <thead>
//           <tr className="bg-orange-50 text-gray-500 uppercase">
//             <th className="px-3 py-2 text-left font-semibold w-8">#</th>
//             <th className="px-3 py-2 text-left font-semibold">MPAN</th>
//             <th className="px-3 py-2 text-left font-semibold">Disposition</th>
//           </tr>
//         </thead>

//         <tbody>
//           {mpanRecords.map((record, index) => (
//             <tr
//               key={index}
//               className="border-t border-orange-100 hover:bg-orange-50 transition"
//             >
//               <td className="px-3 py-2 text-gray-400">
//                 {index + 1}
//               </td>

//               <td className="px-3 py-2 font-mono text-gray-800">
//                 {record.mpan || "—"}
//               </td>

//               <td className="px-3 py-2">
//                 <span
//                   className={`
//                     px-2 py-0.5 rounded text-[10px] font-bold uppercase
//                     ${
//                       record.lead_disposition === "Sale"
//                         ? "bg-green-100 text-green-700"
//                         : record.lead_disposition === "Reject"
//                         ? "bg-red-100 text-red-700"
//                         : record.lead_disposition === "Hold"
//                         ? "bg-yellow-100 text-yellow-700"
//                         : "bg-gray-100 text-gray-600"
//                     }
//                   `}
//                 >
//                   {record.lead_disposition || "—"}
//                 </span>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
// )}

//             {/* MPAN INPUT */}
//             {/* <div className="flex items-center gap-3">
//               <label className="w-36 text-[12px] font-semibold text-gray-700 uppercase">MPAN</label>
//               <input
//                 name="mpan"
//                 type="text"
//                 value={form.mpan || ""}
//                 onChange={setField("mpan")}
//                 placeholder="Enter MPAN"
//                 className="flex-1 border border-gray-400 px-4 py-3 text-sm bg-white focus:outline-none focus:ring-1 focus:ring-blue-500"
//               />
//               {errors.mpan && (                                       
//       <p className="text-red-500 text-[11px] mt-1">{errors.mpan}</p>
//     )}
//             </div> */}

//             {/* MPAN INPUT */}
// {form.validationType !== "Gas Only" && (            
// <div className="flex items-start gap-3">
//   <label className="w-36 text-[12px] font-semibold text-gray-700 uppercase">MPAN</label>
//   <div className="flex-1">                                      {/* ← wrap in div */}
//     <input
//       name="mpan"
//       type="text"
//       value={form.mpan || ""}
//       onChange={setField("mpan")}
//       placeholder="Enter MPAN"
//       className={`
//         w-full border px-4 py-2 text-sm text-gray-900 bg-white
//         focus:outline-none focus:ring-1
//         ${errors.mpan
//           ? "border-red-500 focus:ring-red-400"
//           : "border-gray-400 focus:ring-blue-500"
//         }
//       `}
//     />
//     {errors.mpan && (                                         
//       <p className="text-red-500 text-[11px] mt-1">{errors.mpan}</p>
//     )}
//   </div>
// </div>
// )}
//           </div>

//           {/* POSTAL CODE */}
//           <div className="flex items-start gap-3">
//             <label className="w-44 text-[12px] font-semibold text-gray-700 uppercase pt-3">
//               Business Postal Code *
//             </label>
//             <div className="flex-1">
//               <input
//                 name="postalCode"
//                 type="text"
//                 value={form.postalCode || ""}
//                 onChange={setField("postalCode")}
//                 placeholder="Enter postal code"
//                 className={inputCls(errors.postalCode)}
//               />
//               <FieldError message={errors.postalCode} />
//             </div>
//           </div>

//         </div>
//       </div>
//     </SectionCard>
//   );
// }

import { useMemo, useState } from "react";
import debounce from "lodash.debounce";
import axiosInstance from "../../api/axiosInstance";
import SectionCard from "../ui/SectionCard";
import { validationTypeOptions } from "../../data/formDefaults";

function FieldError({ message }) {
  if (!message) return null;
  return <p className="text-red-500 text-[11px] mt-1">{message}</p>;
}

function inputCls(hasError) {
  return `
    flex-1 border px-10 py-2 text-sm text-gray-800 bg-white
    focus:outline-none focus:ring-1
    ${hasError
      ? "border-red-500 focus:ring-red-400"
      : "border-gray-400 focus:ring-blue-500"
    }
  `;
}

function selectCls(hasError) {
  return `
    flex-1 border px-8 py-1 text-sm text-gray-900 bg-white
    focus:outline-none focus:ring-1
    ${hasError
      ? "border-red-500 focus:ring-red-400"
      : "border-gray-400 focus:ring-blue-500"
    }
  `;
}

export default function GeneralInfoSection({ form, errors, setField }) {

  const user  = JSON.parse(localStorage.getItem("user"));
  console.log("user888888:..... ", user);
  
  const today = new Date().toISOString().split("T")[0];

  // ── Phone check state ─────────────────────────────────
  const [mpanRecords,  setMpanRecords]  = useState([]);
  const [phoneLoading, setPhoneLoading] = useState(false);
   const [phoneError,   setPhoneError]   = useState("");

  // ── MPAN duplicate check state ────────────────────────
  const [mpanError, setMpanError] = useState("");

  // ── CHECK PHONE ───────────────────────────────────────
  const checkPhoneExists = async (phone) => {
    try {
      setPhoneLoading(true);
      const response = await axiosInstance.get(`/leads/check-phone/${phone}`);
      if (response.data.exists) {
        setMpanRecords(response.data.records || []);
      } else {
        setMpanRecords([]);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setPhoneLoading(false);
    }
  };

  const debouncedPhoneCheck = useMemo(
    () => debounce((phone) => checkPhoneExists(phone), 500),
    []
  );

  
 

//   const handlePhoneChange = (e) => {
//   const value = e.target.value.replace(/\D/g, "");

//   // Prevent more than 10 digits
//   if (value.length > 10) {
//     setPhoneError("Phone number must be exactly 10 digits");
//     return;
//   }

//   setField("businessPhone")({
//     target: {
//       name: "businessPhone",
//       value,
//     },
//   });

//   // Validation
//   if (value.length > 0 && value.length !== 10) {
//     setPhoneError("Phone number must be exactly 10 digits");
//     setMpanRecords([]);
//   } else {
//     setPhoneError("");

//     // Check only when exactly 10 digits
//     if (value.length === 10) {
//       debouncedPhoneCheck(value);
//     }
//   }
// };

  // ── CHECK MPAN DUPLICATE ──────────────────────────────
 const handlePhoneChange = (e) => {
  const value = e.target.value.replace(/\D/g, "");

  // Prevent first digit from being 0
  if (value.length === 1 && value === "0") {
    setPhoneError("Phone number cannot start with 0");
    return;
  }

  // Prevent more than 10 digits
  if (value.length > 10) {
    return;
  }

  setField("businessPhone")({
    target: {
      name: "businessPhone",
      value,
    },
  });

  if (value.length > 0 && value.length !== 10) {
    setPhoneError("Phone number must be exactly 10 digits");
    setMpanRecords([]);
  } else {
    setPhoneError("");

    if (value.length === 10) {
      debouncedPhoneCheck(value);
    }
  }
};
  
  const checkMpanExists = async (mpan) => {
    try {
      const response = await axiosInstance.get(
        `/leads/check-mpan-core/${encodeURIComponent(mpan)}`
      );
      if (response.data.exists) {
        setMpanError("This MPAN already exists");
      } else {
        setMpanError("");
      }
    } catch (err) {
      console.error(err);
    }
  };

  const debouncedMpanCheck = useMemo(
    () => debounce((mpan) => checkMpanExists(mpan), 500),
    []
  );

  

  const handleMpanChange = (e) => {
  const value = e.target.value.replace(/\D/g, ""); // digits only, strips spaces/letters

  // Block more than 13 digits
  if (value.length > 13) return;

  setField("mpan")({ target: { name: "mpan", value } });

  // Validation message
  if (value.length > 0 && value.length !== 13) {
    setMpanError(`MPAN must be exactly 13 digits (${value.length}/13)`);
  } else {
    setMpanError("");
    // Only check duplicate when exactly 13 digits
    if (value.length === 13) {
      debouncedMpanCheck(value);
    }
  }
};

  return (
    <SectionCard title="GENERAL INFORMATION">
      <div className="border border-gray-300 bg-[#dbe9f5] p-6">
        <div className="grid grid-cols-2 gap-x-8 gap-y-5">

          {/* LEAD ID */}
          <div className="flex items-center gap-3">
            <label className="w-44 text-[12px] font-semibold text-gray-500 uppercase">Lead ID</label>
            <input
              type="text"
              disabled
              placeholder="Auto Generated"
              className="flex-1 border border-gray-400 px-5 py-1 text-sm bg-gray-100"
            />
          </div>

          <div></div>

          {/* VALIDATE TYPE */}
          <div className="flex items-start gap-3">
            <label className="w-44 text-[12px] font-semibold text-gray-700 uppercase pt-3">
              Validate Type *
            </label>
            <div className="flex-1">
              <select
                name="validationType"
                value={form.validationType || ""}
                onChange={setField("validationType")}
                className={selectCls(errors.validationType)}
              >
                <option value="">Select Type</option>
                {validationTypeOptions.map((item) => (
                  <option key={item} value={item}>{item}</option>
                ))}
              </select>
              <FieldError message={errors.validationType} />
            </div>
          </div>

          {/* AGENT ID */}
          <div className="flex items-center gap-3">
            <label className="w-36 text-[12px] font-semibold text-gray-700 uppercase">Agent ID</label>
            <input
              type="text"
             value={user?.first_name || ""}
              placeholder="Auto Generated"
              disabled
              className="flex-1 border border-gray-400 px-3 py-2 text-sm bg-gray-100"
            />
          </div>

          {/* LEAD DATE */}
          <div className="flex items-center gap-3">
            <label className="w-44 text-[12px] font-semibold text-gray-700 uppercase">Lead Date</label>
            <input
              type="date"
              value={form.leadDate || today}
              disabled
              className="flex-1 border border-gray-400 px-4 py-2 text-sm bg-gray-100 text-gray-900"
            />
          </div>

          {/* CUSTOMER NAME */}
          <div className="flex items-start gap-3">
            <label className="w-36 text-[12px] font-semibold text-gray-700 uppercase pt-3">
              Customer Name *
            </label>
            <div className="flex-1">
              <input
                name="contactName"
                type="text"
                value={form.contactName || ""}
                onChange={setField("contactName")}
                placeholder="Enter customer name"
                className={inputCls(errors.contactName)}
              />
              <FieldError message={errors.contactName} />
            </div>
          </div>

          {/* BUSINESS NAME */}
          <div className="flex items-start gap-3">
            <label className="w-44 text-[12px] font-semibold text-gray-700 uppercase pt-3">
              Business Name *
            </label>
            <div className="flex-1">
              <input
                name="businessName"
                type="text"
                value={form.businessName || ""}
                onChange={setField("businessName")}
                placeholder="Enter business name"
                className={inputCls(errors.businessName)}
              />
              <FieldError message={errors.businessName} />
            </div>
          </div>

          {/* BILLING NAME */}
          <div className="flex items-start gap-3">
            <label className="w-36 text-[12px] font-semibold text-gray-700 uppercase pt-3">
              Billing Name *
            </label>
            <div className="flex-1">
              <input
                name="billingName"
                type="text"
                value={form.billingName || ""}
                onChange={setField("billingName")}
                placeholder="Enter billing name"
                className={inputCls(errors.billingName)}
              />
              <FieldError message={errors.billingName} />
            </div>
          </div>

          {/* BUSINESS ADDRESS */}
          <div className="flex items-start gap-3">
            <label className="w-44 pt-3 text-[12px] font-semibold text-gray-700 uppercase">
              Business Address *
            </label>
            <div className="flex-1">
              <textarea
                name="businessAddress"
                rows={6}
                value={form.businessAddress || ""}
                onChange={setField("businessAddress")}
                placeholder="Enter business address"
                className={`
                  w-full border px-4 py-2 text-sm text-gray-900 bg-white resize-none
                  focus:outline-none focus:ring-1
                  ${errors.businessAddress
                    ? "border-red-500 focus:ring-red-400"
                    : "border-gray-400 focus:ring-blue-500"
                  }
                `}
              />
              <FieldError message={errors.businessAddress} />
            </div>
          </div>

          {/* RIGHT COLUMN: PHONE + MPAN RECORDS + MPAN */}
          <div className="space-y-4">

            {/* PHONE */}
            <div className="flex items-start gap-3">
              <label className="w-36 text-[12px] font-semibold text-gray-700 uppercase pt-3">
                Phone No *
              </label>
              <div className="flex-1">
                <input
                  name="businessPhone"
                  type="tel"
                  value={form.businessPhone || ""}
                  onChange={handlePhoneChange}
                  placeholder="Enter phone number"
                 className={`
  w-full border px-4 py-2 text-sm text-gray-900 bg-white
  focus:outline-none focus:ring-1
  ${errors.businessPhone || phoneError
    ? "border-red-500 focus:ring-red-400"
    : "border-gray-400 focus:ring-blue-500"
  }
`}
                />
             <FieldError message={phoneError || errors.businessPhone} />
              </div>
            </div>

            {/* LOADING */}
            {phoneLoading && (
              <p className="text-xs text-gray-400 italic pl-1">Checking phone...</p>
            )}

            {/* MPAN RECORDS TABLE — only for electricity leads */}
           {/* MPAN/MPRN RECORDS TABLE — shows for all validation types */}
{!phoneLoading && mpanRecords.length > 0 && (
  <div className="border border-orange-300 bg-white rounded overflow-hidden">
    <div className="px-3 py-2 bg-orange-100 border-b border-orange-300">
      <p className="text-[11px] font-bold text-orange-700 uppercase tracking-wide">
        ⚠ Existing Records for this Phone Number
      </p>
    </div>
    <table className="w-full text-xs">
      <thead>
        <tr className="bg-orange-50 text-gray-500 uppercase">
          <th className="px-3 py-2 text-left font-semibold w-8">#</th>
          <th className="px-3 py-2 text-left font-semibold">MPAN</th>
          <th className="px-3 py-2 text-left font-semibold">MPRN</th>
          <th className="px-3 py-2 text-left font-semibold">Disposition</th>
        </tr>
      </thead>
      <tbody>
        {mpanRecords.map((record, index) => (
          <tr
            key={index}
            className="border-t border-orange-100 hover:bg-orange-50 transition"
          >
            <td className="px-3 py-2 text-gray-400">{index + 1}</td>
            <td className="px-3 py-2 font-mono text-gray-800">
              {record.mpan || "—"}
            </td>
            <td className="px-3 py-2 font-mono text-gray-800">
              {record.mprn_no || "—"}
            </td>
            <td className="px-3 py-2">
              <span className={`
                px-2 py-0.5 rounded text-[10px] font-bold uppercase
                ${record.lead_disposition === "Quality"   ? "bg-green-100 text-green-700"
                : record.lead_disposition === "Reject"    ? "bg-red-100 text-red-700"
                : record.lead_disposition === "Hold"      ? "bg-yellow-100 text-yellow-700"
                : record.lead_disposition === "Callback"  ? "bg-orange-100 text-orange-700"
                : "bg-gray-100 text-gray-600"}
              `}>
                {record.lead_disposition || "—"}
              </span>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)}


            {/* MPAN INPUT — only for electricity leads */}
            {form.validationType !== "Gas Only" && (
              <div className="flex items-start gap-3">
                <label className="w-36 text-[12px] font-semibold text-gray-700 uppercase pt-3">
                  MPAN
                </label>
                <div className="flex-1">
                  {/* <input
                    name="mpan"
                    type="text"
                    value={form.mpan || ""}
                    onChange={handleMpanChange}
                    placeholder="e.g. 20 0000 2359 000"
                    className={`
                      w-full border px-4 py-2 text-sm text-gray-900 bg-white
                      focus:outline-none focus:ring-1
                      ${mpanError || errors.mpan
                        ? "border-red-500 focus:ring-red-400"
                        : "border-gray-400 focus:ring-blue-500"
                      }
                    `}
                  /> */}
<input
  name="mpan"
  type="text"
  value={form.mpan || ""}
  onChange={handleMpanChange}
  placeholder="Enter 13 digit MPAN"
  maxLength={13}
  className={`
    w-full border px-4 py-2 text-sm text-gray-900 bg-white
    focus:outline-none focus:ring-1
    ${mpanError || errors.mpan
      ? "border-red-500 focus:ring-red-400"
      : "border-gray-400 focus:ring-blue-500"
    }
  `}
/>
{/* digit counter */}
<p className={`text-xs mt-1 text-right ${
  (form.mpan || "").length === 13 ? "text-green-600 font-semibold" : "text-gray-400"
}`}>
  {(form.mpan || "").length}/13
</p>
<FieldError message={mpanError || errors.mpan} />


            
                
                </div>
              </div>
            )}

          </div>

          {/* POSTAL CODE */}
          <div className="flex items-start gap-3">
            <label className="w-44 text-[12px] font-semibold text-gray-700 uppercase pt-3">
              Business Postal Code *
            </label>
            <div className="flex-1">
              <input
                name="postalCode"
                type="text"
                value={form.postalCode || ""}
                onChange={setField("postalCode")}
                placeholder="Enter postal code"
                className={inputCls(errors.postalCode)}
              />
              <FieldError message={errors.postalCode} />
            </div>
          </div>

        </div>
      </div>
    </SectionCard>
  );
}

